import { useEffect, useState } from 'react';
import { detectSketchplanCurrency, persistBillingCurrency, type SketchplanCurrency } from '@rehub/pricing';

const CURRENCY_EVENT = 'sketchplan:currency';

export function selectSketchplanCurrency(currency: SketchplanCurrency): void {
  persistBillingCurrency(currency);
  window.dispatchEvent(new CustomEvent<SketchplanCurrency>(CURRENCY_EVENT, { detail: currency }));
}

/** Display currency shared by every price on the page; follows any CurrencyToggle. */
export function useSketchplanCurrency(): [SketchplanCurrency, (currency: SketchplanCurrency) => void] {
  const [currency, setCurrency] = useState<SketchplanCurrency>(detectSketchplanCurrency);
  useEffect(() => {
    const onChange = (event: Event) => setCurrency((event as CustomEvent<SketchplanCurrency>).detail);
    window.addEventListener(CURRENCY_EVENT, onChange);
    return () => window.removeEventListener(CURRENCY_EVENT, onChange);
  }, []);
  return [currency, selectSketchplanCurrency];
}
